<div class="flex justify-left align-center w-full h-full flex justify-center align-center ">
  <!--<span class=" text-5xl  text-red-500  font-bold">CCMS</span><span class="ml-1 text-blue-200"></span>-->
<!--
  <img class="h-24" src="assets/images/ccms.svg" alt="CCMS Logo with Text" />
-->
  <img class="h-20 cursor-pointer px-3 pt-2 object-contain" [src]="tenant.getTenantLogoUrl()" alt="Tenant Logo with Text"  (click)="handleRoute()"/>
</div>


